import { observer } from "mobx-react"
import React, { useState } from "react"
import "../../styles/Common/FlipCard.less"

const FlipCard = observer(({ front, back, id }) => { // Getting props from other comp
  const [flipped, setFlipped] = useState(false) //Setting default flipped state = false
  const handleOver = () => { // on Mouse Over this func will trigger & will set flipped state = true
    setFlipped(true)
  }
  const handleLeave = () => { // on Mouse Leave this func will trigger & will set flipped state = false
    setFlipped(false)
  }

  return (
    <div className="FlipCardRoot" id={id}>
      <div
        className={`card ${flipped}`}
        onMouseOver={handleOver}
        onMouseLeave={handleLeave}
        onClick={flipped ? handleLeave : handleOver}
      >
        {front}
        {back}
      </div>
    </div>
  )
})

export default FlipCard
